<template>
    <div class="flex justify-between items-center p-6 border-b">
        <div>
            <h2 class="title-subsection text-ink">{{ title ?? t("feedback.modal.defaultTitle") }}</h2>
            <p v-if="subTitle" class="mt-2 body-small text-ink-muted">{{ subTitle }}</p>
        </div>

        <div class="flex items-center gap-3">
            <!-- Action buttons slot (e.g., "Create with Nadia" button) -->
            <slot name="actions" />

            <!-- Back button (optional) -->
            <BaseButton v-if="showBackButton" theme="neutral" class="border-none p-1" :aria-label="t('feedback.modal.backButton')" @click="$emit('back')">
                <i class="bi bi-arrow-left text-xl text-ink-muted" aria-hidden="true"></i>
            </BaseButton>

            <!-- Close button -->
            <BaseButton theme="neutral" class="border-none p-1" :aria-label="t('feedback.modal.closeButton')" @click="$emit('close')">
                <i class="bi bi-x text-2xl text-ink-muted" aria-hidden="true"></i>
            </BaseButton>
        </div>
    </div>
</template>

<script setup>
import BaseButton from "~vue/components/BaseButton.vue";
import { useI18n } from "vue-i18n";

defineProps({
    title: {
        type: String,
        default: null,
    },
    subTitle: {
        type: [String, null],
        default: null,
    },
    showBackButton: {
        type: Boolean,
        default: false,
    },
});

defineEmits(["close", "back"]);

const { t } = useI18n();
</script>
